export default __webpack_public_path__ + "static/media/042-deposit.5de7e8bb.svg";